export default import.meta.ROLLDOWN_FILE_URL_yK4AGQI2OZk7MdRgobs9JA